import { RichText } from '@/components/shared/RichText';
import { CONTACT_SECTIONS, type ContactSection } from './contact-content';

/**
 * Contact page (BFL-1560): claims mailing information, electronic payment resources and EDI support.
 *
 * Copy comes verbatim from the client's `09-Contact Page content` document; the page only lays it out.
 */
export function ContactPage(): React.JSX.Element {
  return (
    <section aria-labelledby="contact-heading" className="flex flex-col gap-5">
      <header>
        <h1 id="contact-heading" className="text-brand-600 text-xl font-bold">
          Contact
        </h1>
        <p className="text-muted mt-1 text-sm">
          Claims mailing information, electronic payment resources, and EDI support.
        </p>
      </header>

      {CONTACT_SECTIONS.map((section) => (
        <Section key={section.title} section={section} />
      ))}
    </section>
  );
}

function Section({ section }: { section: ContactSection }): React.JSX.Element {
  return (
    <section
      aria-label={section.title}
      className="border-line bg-surface rounded-xl border p-6 shadow-sm"
    >
      <h2 className="text-brand-600 border-line border-b pb-3 text-base font-bold">
        {section.title}
      </h2>

      <div className="text-muted mt-4 text-sm leading-relaxed">
        <RichText blocks={section.blocks} />
      </div>
    </section>
  );
}
